import {Parameter, ToolboxMergeMerge} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum PagesAddModeEnum {
	AtTheEnd = "atTheEnd",
	AtTheBeginning = "atTheBeginning",
	AfterPage = "afterPage",
	BeforePage = "beforePage",
	replace = "replace"
}

export class PortalPagesAdd extends ToolboxMergeMerge implements Parameter {
	public addMode?: PagesAddModeEnum;

	constructor(data: any) {
		super(data);

		this.addMode = FunctionHelper.exists(data?.addMode) ? data.addMode : PagesAddModeEnum.AtTheEnd;
	}

	public static getAddModeDefault(): PagesAddModeEnum {
		return PagesAddModeEnum.AtTheEnd;
	}

	public static fromJson(data: any): PortalPagesAdd {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalPagesAdd(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'addMode': this.addMode
		};
	}

	public clone(): PortalPagesAdd {
		return PortalPagesAdd.fromJson(this.toJson());
	}
}